(()=>{
 const day=86400000,pkOffset=18000000;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');const clearFlips=new WeakMap();
 function updateDigit(element,value){
  if(element.dataset.value===value)return;
  const previous=element.dataset.value;clearTimeout(clearFlips.get(element));element.classList.remove('is-flipping');
  element.dataset.value=value;element.textContent=value;
  if(previous!==undefined&&!reduced.matches&&!document.hidden){element.dataset.old=previous;void element.offsetWidth;element.classList.add('is-flipping');clearFlips.set(element,setTimeout(()=>element.classList.remove('is-flipping'),850))}
 }
 function init(scope=document){
  scope.querySelectorAll('[data-sale-daily]:not([data-sale-ready])').forEach(bar=>{
   bar.dataset.saleReady='true';let timer;
   function tick(){
    const now=Date.now();const midnight=(Math.floor((now+pkOffset)/day)+1)*day-pkOffset;
    const seconds=Math.ceil((midnight-now)/1000);
    const values=[Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60];
    bar.querySelectorAll('[data-sale-unit]').forEach((e,i)=>updateDigit(e,String(values[i]).padStart(2,'0')));bar.hidden=false;
   }
   tick();timer=setInterval(()=>{if(!bar.isConnected){clearInterval(timer);document.removeEventListener('visibilitychange',tick);return}tick()},1000);
   document.addEventListener('visibilitychange',tick);
  });
 }
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
